import React from 'react';
import { Checkbox, Menu, Dropdown } from 'antd';
import DownOutlined from '@ant-design/icons/DownOutlined';

import useSelection from './useSelection';

const useTableSelection = ({ rowKey, pageData = [] }) => {
  const {
    isSelected,
    selectedKeys,
    clearSelectedKeys,
    onSingleSelection,
    onSelectAllChange,
    selectOptions,
    checkedCurrentAll,
    checkedCurrentSome,
  } = useSelection({ rowKey, pageData });

  const checkbox = (record) => (
    <Checkbox
      checked={isSelected(record)}
      onClick={(e) => e.stopPropagation()}
      onChange={({ nativeEvent }) => onSingleSelection({ record, nativeEvent })}
    />
  );

  const checkboxColumn = {
    onCell: () => ({
      style: { width: 50, paddingRight: 5 },
    }),
    render: checkbox,
  };

  const menu = (
    <Menu>
      {selectOptions.map((selection, index) => {
        const { key, text, onSelect: onSelectionClick } = selection;
        return (
          <Menu.Item key={key || index} onClick={onSelectionClick}>
            {text}
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const customizeSelections = (
    // TODO: get antd prefix
    <div className="ant-table-selection-extra">
      <Dropdown overlay={menu}>
        <span>
          <DownOutlined />
        </span>
      </Dropdown>
    </div>
  );

  const checkboxSelectOptions = (
    // TODO: get antd prefix
    <div className="ant-table-selection">
      <Checkbox
        checked={!!pageData.length && checkedCurrentAll}
        indeterminate={!checkedCurrentAll && checkedCurrentSome}
        onChange={onSelectAllChange}
        disabled={pageData.length === 0}
      />
      {customizeSelections}
    </div>
  );

  return {
    isSelected,
    selectedKeys,
    clearSelectedKeys,
    selected: selectedKeys.length,

    checkbox,
    checkboxColumn,
    checkboxSelectOptions,
  };
};

export default useTableSelection;
